import config from '../config';

export async function fetchPartnerCompanies(backendFetch) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/partner-company")
    return await response.json();
}